"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GuidesHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative min-h-screen w-full overflow-hidden bg-cover bg-center bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1496898/img/guides_hero_background_neon_gradient.png)]">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1496898/img/guides_hero_glitch_overlay.png)] bg-cover bg-center opacity-20 animate-pulse" />

      {}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-primary/30 to-transparent" />

      <div className={`relative z-10 container mx-auto px-6 flex flex-col items-center justify-center min-h-screen transition-all duration-200 ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        {}
        <div className="glass-effect border-2 border-primary px-8 py-6 mb-6 max-w-4xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-foreground text-center leading-tight">
            Master the Agentic Architecture
          </h1>
        </div>

        {}
        <div className="bg-primary-light/80 backdrop-blur-sm rounded-lg px-6 py-4 mb-10 max-w-2xl">
          <p className="text-lg md:text-xl text-foreground-light text-center">
            Two comprehensive e-books to remix your workflow and reclaim your rhythm.
          </p>
        </div>

        {}
        <Link to="#guides-library">
          <Button size="lg" className="btn-primary shadow-[0_0_20px_rgba(59,130,246,0.5)] hover:shadow-[0_0_30px_rgba(59,130,246,0.8)] hover:scale-[1.04] active:scale-100 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] animate-pulse">
            Download Your Guides
          </Button>
        </Link>
      </div>
    </section>;
}